export default __webpack_public_path__ + "static/media/paid.49c2295a.png";